import axios from "axios";
import { Navigate } from "react-router-dom";

/**
 * Checks if an axios error is an authentication/authorization failure (401 or 403).
 * If so, throws a structured error that callers can detect and handle.
 * Otherwise, re-throws the original error.
 */
const handleApiError = (err) => {
  const status = err.response?.status;
  if (status === 401 || status === 403) {
    const authError = new Error(
      "Su sesión ha expirado. Por favor intente nuevamente, si el error persiste vuelva a iniciar sesión.",
    );
    authError.isAuthError = true;
    authError.status = status;
    throw authError;
  }
  throw err;
};

export const load_patient_list = async (data, pageUrl = null) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    if (data) {
      config.params = {
        ...data,
      };
    }
    const url = pageUrl
      ? pageUrl
      : `${process.env.REACT_APP_API_URL}/clinical_api/pacientes/`;

    try {
      const response = await axios.get(url, config);

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const load_patient_data_from_id = async (patientId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}`,
        config,
      );
      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const edit_patient = async (patientId, data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const upload_patient = async (data, files) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };
    const fixedData = { ...data };

    function getFormData(object) {
      const formData = new FormData();
      Object.keys(object).forEach((key) => {
        if (
          (object[key] && typeof object[key] == "object") ||
          Array.isArray(object[key])
        ) {
          formData.append(key, JSON.stringify(object[key]));
          console.log(object[key]);
        } else {
          formData.append(key, object[key]);
        }
      });
      return formData;
    }

    const fData = getFormData(fixedData);
    files.forEach((file, index) => {
      fData.append(`files_${index}`, file.file, file.name); // Appending files with their original names
    });

    // for (const [key, value] of fData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clinical_api/registrar_paciente/`,
        fData,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const import_patients = async (file) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clinical_api/importar_pacientes/`,
        formData,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
// Patient File management
export const load_patient_file_list = async (patientId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/archivos/`,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const upload_patient_file = async (patientId, file) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/archivos/`,
        formData,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const delete_patient_file = async (patientId, fileId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/archivos/${fileId}`,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
// Patient evolutions
export const load_patient_evolution_list = async (
  patientId,
  evolution_list,
  pageUrl = null,
) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    if (evolution_list) {
      config.params = {
        evolution_list: evolution_list,
      };
    }

    const url = pageUrl
      ? pageUrl
      : `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/evoluciones/`;

    try {
      const response = await axios.get(url, config);

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const upload_patient_evolution = async (patientId, evo_data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...evo_data });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/evoluciones/`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const modify_patient_evolution = async (patientId, evoId, evo_data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...evo_data });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/evoluciones/${evoId}`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const delete_patient_evolution = async (patientId, evoId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/evoluciones/${evoId}`,
        config,
      );

      return response.status;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const load_patient_fichas_list = async (patientId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fichas/`,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const modify_patient_ficha = async (patientId, id, data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fichas/${id}`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const upload_patient_ficha = async (patientId, data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fichas/`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const delete_patient_ficha = async (patientId, id) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fichas/${id}`,
        config,
      );

      return response.status;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const generar_ficha_evoluciones_paciente = async (patientId, id) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fichas/${id}/generar_ficha/`,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const generar_ficha_paciente = async (patientId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/generar_ficha/`,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const load_fms_from_patient_id = async (patientId) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fms/`,
        config,
      );
      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const edit_patient_fms = async (patientId, data) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/clinical_api/paciente/${patientId}/fms/`,
        body,
        config,
      );

      return response.data;
    } catch (err) {
      throw handleApiError(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
